{
    "Accessibility Menu": "Μενού προσβασιμότητας",
    "Reset settings": "Επαναφορά ρυθμίσεων",
    "Close": "Κλείσιμο",
    "Content Adjustments": "Προσαρμογές περιεχομένου",
    "Adjust Font Size": "Προσαρμογή μεγέθους γραμματοσειράς",
    "Highlight Title": "Επισήμανση τίτλου",
    "Highlight Links": "Επισήμανση συνδέσμων",
    "Readable Font": "Ευανάγνωστη γραμματοσειρά",
    "Color Adjustments": "Προσαρμογές χρωμάτων",
    "Dark Contrast": "Αντίθεση σε σκούρο",
    "Light Contrast": "Αντίθεση σε φωτεινό",
    "High Contrast": "Υψηλή αντίθεση",
    "High Saturation": "Υψηλός κορεσμός",
    "Low Saturation": "Χαμηλός κορεσμός",
    "Monochrome": "Μονόχρωμο",
    "Tools": "Εργαλεία",
    "Reading Guide": "Οδηγός ανάγνωσης",
    "Stop Animations": "Αφαίρεση κίνησης",
    "Big Cursor": "Μεγάλος κέρσορας",
    "Increase Font Size": "Αύξηση μεγέθους γραμματοσειράς",
    "Decrease Font Size": "Μείωση μεγέθους γραμματοσειράς",
    "Letter Spacing": "Διάκενο γραμμάτων",
    "Line Height": "Ύψος γραμμής",
    "Font Weight": "Βάρος γραμματοσειράς",
    "Dyslexia Font": "Γραμματοσειρά για δυσλεξία",
    "Language": "Γλώσσα",
    "Open Accessibility Menu": "Ανοίξτε το μενού προσβασιμότητας"
}
  